import { Client, ContractorType, InspectionStatus, InspectionVM, Workflow, WorkflowType } from ".";
import { DataEntity } from "./data-entities";
import { RegistrationStatus } from "./registration";

export class SearchWorkflowsRequest {
  constructor() {
    this.page = 1;
    this.pageSize = 50;
  }
  activityTypes?: string;
  dataEntityType?: string;
  hasValidationErrors?: boolean;
  hasCustomLists?: boolean;
  workflowType?: string;
  page: number;
  pageSize: number;
}

export class WorkflowSearchVM {
  workflowId: string;
  workflowName: string;
  clientId: string;
  clientName: string;
  activityId: string;
  activityName: string;
}

export class SearchWorkflowsResponse {
  workflows: WorkflowSearchVM[];
  totalRecords: number;
}

export class SearchJurisdictionsRequest {
  constructor() {
    this.page = 1;
    this.pageSize = 50;
  }
  hasCustomLists?: boolean;
  hasActiveRegistrations?: boolean;
  workflowType?: string;
  page: number;
  pageSize: number;
}
export class SearchJurisdictionsResponse {
  jurisdictions: Client[];
  totalRecords: number;
}

export class SearchInspectionsRequest {
  constructor() {
    this.page = 1;
    this.pageSize = 50;
  }
  status: InspectionStatus;
  page: number;
  pageSize: number;
}

export class SearchInspectionsResponse {
  inspections: InspectionVM[];
  totalRecords: number;
}

export class SearchContractorsRequest {
  constructor() {
    this.page = 1;
    this.pageSize = 50;
  }
  hasRegistrationStatus?: string;
  hasContractorRequirements?: boolean;
  hasRegistrationRequirements?: boolean;
  page: number;
  pageSize: number;
}

export class SearchContractorsResponse {
  contractors: SearchContractorsResult[];
  totalRecords: number;
}

export class SearchContractorsResult {
  contractorId: string;
  contractorTypeId: string;
  contractorTypeName: string;
  requirementLabel: string;
  requirementTemplateCode: string;
  registrationId: string;
  clientId: string;
  clientName: string;
  businessName: string;
  registrationStatus: number;
}

export class SearchContractorTypesRequest {
  constructor() {
    this.page = 1;
    this.pageSize = 50;
  }
  hasRequirements?: boolean;
  hasRegistrationStatus?: RegistrationStatus;
  page: number
  pageSize: number;
}

export class SearchContractorTypesResponse {
  contractorTypes: ContractorType[];
  totalRecords: number;
}

export class SearchDataEntitiesRequest {
  constructor() {
    this.page = 1;
    this.pageSize = 50;
  }
  hasCustomLists: boolean;
  page: number;
  pageSize: number;
}

export class SearchDataEntitiesResponse {
  dataEntities: DataEntity[];
  totalRecords: number;
}
